import MilitaryInfoCard from './MilitaryInfoCardContainer';

export default MilitaryInfoCard;
